module.exports = __webpack_public_path__ + "img/home_img04.b22f469b.png";